module.exports = {
  messages: {
    JOBS_JOB_DETAILS_SE_DEFAULT_PAGETITLE: 'Search results in jobs',
    JOBS_JOB_DETAILS_SE_DEFAULT_PAGETITLE_SUFFIX: 'XING Search',
    JOBS_JOB_DETAILS_SEO_META_DESCRIPTION_TAG_POSTING_DETAIL:
      "Apply for the position of ''{function}'' at {company_name} in {city}. Industry: {industry} / Job type: {job_type} / Career level: {level} / Posted on: {date}",
    JOBS_JOB_DETAILS_SEO_TITLE_TAG_LOGGED_IN: 'Job: {job_title}',
    JOBS_JOB_DETAILS_SEO_TITLE_TAG_LOGGED_OUT:
      '{job_title} in {work_location}\n\n\n',
    JOBS_JOB_DETAILS_TITLEBAR_SUFFIX: 'XING Jobs',
  },
};
